import { isFedRamp } from '@atlassian/atl-context';

import type { ContentAnalyticsLinkProps } from './ContentAnalyticsLink';

export const PATH = '/wiki/plugins/servlet/ac/com.addonengine.analytics/analytics-content-page';
export const FEDRAMP_PATH =
	'/wiki/plugins/servlet/ac/com.addonengine.analytics.moderate/analytics-content-page';

type GetContentAnalyticsLinkReturnType = string | null;

export const getContentAnalyticsLink = ({
	contentId,
	contentTab,
	contentType,
}: Omit<ContentAnalyticsLinkProps, 'children' | 'testId'>): GetContentAnalyticsLinkReturnType => {
	const isFedrampEnv = isFedRamp();

	if (!contentId || !contentType) {
		return null;
	}

	const queryParams = new URLSearchParams({
		'content.id': contentId,
		'content.type': contentType,
	});

	if (contentTab) {
		queryParams.append('ac.view', contentTab);
	}

	return `${isFedrampEnv ? FEDRAMP_PATH : PATH}?${queryParams}`;
};
